import React from "react";
import { useSelector } from "react-redux";
import ClaimBasicSection from "./ClaimBasicSection";
import ClaimBusinessSection from "./ClaimBusinessSection";
import ClaimOTPSection from "./ClaimOTPSection";

function ClaimContentSection() {
  const { step } = useSelector((state) => state.user);

  switch (step) {
    case 1:
      return <ClaimBasicSection />;
    case 2:
      return <ClaimBusinessSection />;
    case 3:
      return <ClaimOTPSection />;
  }
  return <div></div>;
}

export default ClaimContentSection;
